import React, { createContext, useReducer } from 'react';

export const PostContext = createContext();

const initialState = {
  posts: JSON.parse(localStorage.getItem('posts')) || []
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'CREATE_POST': {
      const updatedPosts = [...state.posts, action.payload];
      localStorage.setItem('posts', JSON.stringify(updatedPosts));
      return { ...state, posts: updatedPosts };
    }
    case 'DELETE_POST': {
      const updatedPosts = [...state.posts];
      updatedPosts.splice(action.payload, 1);
      localStorage.setItem('posts', JSON.stringify(updatedPosts));
      return { ...state, posts: updatedPosts };
    }
    default:
      return state;
  }
};

export const PostProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <PostContext.Provider value={{ state, dispatch }}>
      {children}
    </PostContext.Provider>
  );
};